"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
// (C) 2021-2022 GoodData Corporation
var Book_1 = require("./icons/Book");
var Lock_1 = require("./icons/Lock");
var Refresh_1 = require("./icons/Refresh");
var DrillDown_1 = require("./icons/DrillDown");
var DrillToDashboard_1 = require("./icons/DrillToDashboard");
var DrillToInsight_1 = require("./icons/DrillToInsight");
var Date_1 = require("./icons/Date");
var Explore_1 = require("./icons/Explore");
var Logout_1 = require("./icons/Logout");
var Pdf_1 = require("./icons/Pdf");
var ExternalLink_1 = require("./icons/ExternalLink");
var Hyperlink_1 = require("./icons/Hyperlink");
var Undo_1 = require("./icons/Undo");
var Home_1 = require("./icons/Home");
var BurgerMenu_1 = require("./icons/BurgerMenu");
var Rows_1 = require("./icons/Rows");
var DragHandle_1 = require("./icons/DragHandle");
var Interaction_1 = require("./icons/Interaction");
var AttributeFilter_1 = require("./icons/AttributeFilter");
var LegendMenu_1 = require("./icons/LegendMenu");
var ArrowDown_1 = require("./icons/ArrowDown");
var ArrowUp_1 = require("./icons/ArrowUp");
var Attribute_1 = require("./icons/Attribute");
var Close_1 = require("./icons/Close");
var Expand_1 = require("./icons/Expand");
var Fact_1 = require("./icons/Fact");
var Function_1 = require("./icons/Function");
var Insight_1 = require("./icons/Insight");
var Keyword_1 = require("./icons/Keyword");
var Label_1 = require("./icons/Label");
var Metric_1 = require("./icons/Metric");
var QuestionMark_1 = require("./icons/QuestionMark");
var Minimize_1 = require("./icons/Minimize");
/**
 * @internal
 */
exports.Icon = {
    Book: Book_1.Book,
    Refresh: Refresh_1.Refresh,
    DrillDown: DrillDown_1.DrillDown,
    DrillToDashboard: DrillToDashboard_1.DrillToDashboard,
    DrillToInsight: DrillToInsight_1.DrillToInsight,
    Date: Date_1.Date,
    Explore: Explore_1.Explore,
    Logout: Logout_1.Logout,
    Lock: Lock_1.Lock,
    Pdf: Pdf_1.Pdf,
    ExternalLink: ExternalLink_1.ExternalLink,
    Hyperlink: Hyperlink_1.Hyperlink,
    Undo: Undo_1.Undo,
    Home: Home_1.Home,
    BurgerMenu: BurgerMenu_1.BurgerMenu,
    Rows: Rows_1.Rows,
    DragHandle: DragHandle_1.DragHandle,
    Interaction: Interaction_1.Interaction,
    AttributeFilter: AttributeFilter_1.AttributeFilter,
    LegendMenu: LegendMenu_1.LegendMenu,
    ArrowDown: ArrowDown_1.ArrowDown,
    ArrowUp: ArrowUp_1.ArrowUp,
    Attribute: Attribute_1.Attribute,
    Close: Close_1.Close,
    Expand: Expand_1.Expand,
    Fact: Fact_1.Fact,
    Function: Function_1.Function,
    Insight: Insight_1.Insight,
    Keyword: Keyword_1.Keyword,
    Label: Label_1.Label,
    Metric: Metric_1.Metric,
    QuestionMark: QuestionMark_1.QuestionMark,
    Minimize: Minimize_1.Minimize,
};
//# sourceMappingURL=Icon.js.map